import React from "react";
import { connect } from "react-redux";
import ContentEditable from "react-contenteditable";
import { Row, Col, Label, InputGroup, Badge } from "reactstrap";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import { deepClone } from "../../../../helpers/objectHelper";
import { conditionActions } from "../../../../store/actions/cms/condition.action";
import { displayMoney, preciseRound } from "../../../../helpers/moneyHelpers";
import "./Event.css";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { attendeeActions } from "../../../../store/actions/attendee/attendee.action";
import { handleResponse } from "../../../../helpers/handleresponse";
import TinyEditor from "../../../components/plugins/tiny_plugin/TinyEditor";
import { toKebabCase } from "../../../../helpers/cssHelper";
import JirangoCheckbox2 from "../../../../components/UI/Checkbox/JirangoCheckbox2";
import { element } from "../../../../store/reducers/cms/form/element/element.reducer";
import { attendee } from "../../../../store/reducers/attendee/attendee.reducer";
import { TramRounded } from "@material-ui/icons";

class Event extends React.Component {
  state = {
    checkboxHasChanged: false,
    isOpen: false,
    loadingBookingRequest: false,
    currentOrderId: undefined,
    isFetching: false,
    forceRerender: true,
  };
  componentDidMount() {
    if (!this.props.cms.editMode && this.props.element.data.preChecked) {
      if (this.props.element.data.hidden && this.props.element.data.doNotExistIfHidden === true) {
        return;
      } else {
        this.checkAvailableStatus(true, true);
      }
    } else {
      this.checkAvailableStatus();
    }
  }

  componentDidUpdate(prevProps) {
    const { attendee } = this.props;

    if (attendee.activePersonNo != prevProps.activePersonNo && this.props.element.data.preChecked && attendee.orders.length > 0 && this.props.element.data.readOnly) {
      if (this.props.element.data.hidden && this.props.element.data.doNotExistIfHidden === true) {
        return;
      } else {
        this.checkAvailableStatus(true, true);
      }
    }

    /*     if(attendee.orders.length > 0 && attendee.orders[attendee.activePersonNo]?.orderRow.length != prevProps.attendee.orders[attendee.activePersonNo]?.orderRow.length ){

      console.log('ORDER HAS CHANGED!!!!')
    }
 */
    /* else if (attendee && attendee.orders && attendee.orders.length > 0) {
      let orderId = attendee.orders[attendee.activePersonNo].orderId;
      if (orderId !== this.state.currentOrderId) {
        this.setState({ currentOrderId: orderId }, this.checkAvailableStatus);
      }
    } */
  }

  handleUpdate = (element) => {
    const { dispatch, cms } = this.props;
    dispatch(formActions.updateFormElement(element));
    if (!cms.editMode) {
      dispatch(conditionActions.triggerCheck(element.formElementId));
    }
  };
  isChangeLocked = () => {
    const { element, attendee } = this.props;
    if (attendee && attendee.orders && attendee.orders.length > 0 && this.props.attendee.orders[0].orderId !== undefined && element.data.changeLock) {
      return true;
    }
    return false;
  };
  handleChange = (e, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.element);
    let val = e && e.target === undefined ? e : e.target !== undefined ? e.target.value : "";
    element[names[0]][names[1]] = val;
    this.handleUpdate(element);
  };
  checkForOverbooking = (isChecked) => {
    const reqEvent = deepClone(this.props.element);
    const events = this.props.form.formElements.filter((fe) => {
      return fe.type === elementConstants.EVENT && fe.id !== reqEvent.id;
    });
    events.map((e) => {
      if (!e.data.allowOverbooking && e.page === this.props.form.currentPage) {
        if (
          (+new Date(e.props.startDateTime) > +new Date(reqEvent.props.startDateTime) && +new Date(e.props.startDateTime) < +new Date(reqEvent.props.endDateTime)) ||
          (+new Date(e.props.endDateTime) > +new Date(reqEvent.props.startDateTime) && +new Date(e.props.endDateTime) <= +new Date(reqEvent.props.endDateTime))
        ) {
          let element = deepClone(e);
          element.data.readOnly = isChecked && !e.props.isSelected;
          this.handleUpdate(element);
        }
      }
    });

    reqEvent.props.isSelected = isChecked;
    this.handleUpdate(reqEvent);
  };
  checkGroupAvailableStatus = (groupId, value) => {
    const reqEvent = deepClone(this.props.element);
    const eventsIncReq = this.props.form.formElements.filter((fe) => {
      return fe.type === elementConstants.EVENT && fe.data.groupId === groupId;
    });
    const events = this.props.form.formElements.filter((fe) => {
      return fe.type === elementConstants.EVENT && fe.id !== reqEvent.id && fe.data.groupId === groupId;
    });
    const container = this.props.form.formElements.find((fe) => {
      return fe.type === elementConstants.CONTAINER && fe.id === groupId;
    });

    if (!container || events.length === 0) return;

    let checkedEvent = events.filter((e) => {
      return e.props.isSelected === true;
    }).length;
    if (parseInt(container.data.extra.max) === 1 && checkedEvent === parseInt(container.data.extra.max) && value) {
      eventsIncReq.map((e) => {
        let element = deepClone(e);
        if (element.id === reqEvent.id) {
          this.handleCheckboxChangeGroup(true, element.id);
          element.props.isSelected = true;
        } else {
          this.handleCheckboxChangeGroup(false, element.id);
          element.props.isSelected = false;
        }
        this.handleUpdate(element);
      });
    } else if (parseInt(container.data.extra.max) > 0 && checkedEvent === parseInt(container.data.extra.max) - 1 && parseInt(container.data.extra.max) > 1) {
      events.map((e) => {
        let element = deepClone(e);
        element.data.readOnly = value && !e.props.isSelected;
        this.handleUpdate(element);
      });
      reqEvent.props.isSelected = value;
      this.handleCheckboxChangeGroup(value, reqEvent.id);
    }
  };
  isRadio = () => {
    const { element } = this.props;
    if (element.parentId !== null && element.data.groupId > 0) {
      const container = this.props.form.formElements.find((fe) => {
        return fe.type === elementConstants.CONTAINER && fe.id === element.data.groupId;
      });
      if (!container) return false;
      if (parseInt(container.data.extra.max) === 1) return true;
    }
    return false;
  };
  checkAvailableStatus = (value, preChecked = false) => {
    if (this.props.element.parentId !== null && this.props.element.data.groupId > -1 && value !== undefined) {
      this.checkGroupAvailableStatus(this.props.element.data.groupId, value);
    }
    if (value === false) {
      this.handleCheckboxChange(false);
    } else {
      this.setState({ loadingBookingRequest: true });
      const requestOptions = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      };
      const { currentOrderId } = this.state;
      if (this.state.isFetching === false) {
        this.setState({ isFetching: true });
        fetch(`./api/attendee/status/${this.props.element.id}${currentOrderId ? "/" + currentOrderId : ""}`, requestOptions)
          .then(handleResponse)
          .then((response) => {
            if (response.available) {
              if (value) {
                this.handleCheckboxChange(true, preChecked);
              }
              this.setFullbooked(false);
            } else {
              this.setFullbooked(true);
            }
            this.setState({ isFetching: false });
          })
          .catch((err) => {
            this.setState({ isFetching: false });
            console.error(err);
          });
      } else {
        setTimeout(() => this.checkAvailableStatus(value, preChecked), 500);
      }
    }
  };

  setFullbooked = (value) => {
    this.setState({ fullbooked: value, loadingBookingRequest: false });
  };
  handleCheckboxChangeGroup = (value, eventId) => {
    const { cms, element, attendee, dispatch } = this.props;
    if (attendee && attendee.orders) {
      let order = attendee.orders[attendee.activePersonNo];
      let newOrder = deepClone(order);
      if (!newOrder.orderRow) {
        newOrder.orderRow = [];
      }
      let row = newOrder.orderRow.find((or) => or.eventId == eventId);
      if (!row) {
        newOrder.orderRow.push({
          amount: element.props.amount,
          comment: "",
          discount: 0,
          eventId: element.id,
          orderId: -1,
          orderRowId: newOrder.orderRow.length * -1,
          quantity: 1,
          status: null,
          vatPercent: element.props.vatPercent ? element.props.vatPercent : 0,
          deleted: false,
        });
      } else {
        row.deleted = !value;
      }
      newOrder.orderRow = newOrder.orderRow.filter((orow) => {
        return !orow.deleted;
      });
      dispatch(attendeeActions.updateOrder(newOrder, attendee.activePersonNo));
    }
    if (this.state.loadingBookingRequest) this.setState({ loadingBookingRequest: false });
    dispatch(conditionActions.triggerCheck(element.formElementId));

    this.checkForOverbooking(value);
  };
  handleCheckboxChange = (value, preChecked) => {
    const { cms, element, attendee, dispatch } = this.props;
    if (attendee && attendee.orders) {
      let order = attendee.orders[attendee.activePersonNo];
      let newOrder = deepClone(order);
      if (!newOrder.orderRow) {
        newOrder.orderRow = [];
      }
      let row = newOrder.orderRow.find((or) => or.eventId == element.id);
      if (!row) {
        newOrder.orderRow.push({
          amount: element.props.amount,
          comment: "",
          discount: 0,
          eventId: element.id,
          orderId: -1,
          orderRowId: newOrder.orderRow.length * -1,
          quantity: 1,
          status: null,
          vatPercent: element.props.vatPercent ? element.props.vatPercent : 0,
          deleted: false,
        });
      } else if (!preChecked) {
        row.deleted = !value;
      }

      newOrder.orderRow = newOrder.orderRow.filter((orow) => {
        return !orow.deleted;
      });

      dispatch(attendeeActions.updateOrder(newOrder, attendee.activePersonNo));
/*       setTimeout(() => {
        this.setState({ forceRerender: true });
      }, 4000); */
      console.log(newOrder.orderRow);
    }
    if (this.state.loadingBookingRequest) this.setState({ loadingBookingRequest: false });
    dispatch(conditionActions.triggerCheck(element.formElementId));

    this.checkForOverbooking(value);
  };

  checkboxHandler = () => {
    const { element, attendee, cms } = this.props;
    let isSelected = false;
    if (attendee && attendee.orders && attendee.orders.length > 0) {
      let order = attendee.orders[attendee.activePersonNo];
      if (order.orderRow) {
        let row = order.orderRow.find((or) => or.eventId == element.id);
      
        if (row && !row.deleted) {
          isSelected = true;
        }
      }
    } else if (cms.editMode && element.data.preChecked === true) {
      isSelected = true;
    }
    return isSelected;
  };
  formatDate = (date, datePath, timePath) => {
    const { element } = this.props;
    if (element.data.display[datePath] && !element.data.display[timePath]) return date.substring(0, 11).replace("T", " ");
    else if (!element.data.display[datePath] && element.data.display[timePath]) {
      return date.substring(11, 16).replace("T", " ");
    } else return date.substring(0, 16).replace("T", " ");
  };
  displayDiscount = () => {
    const { element, form, orders, activePersonNo, cms } = this.props;
    let discountAmount = 0;

    let discounts = this.props.discounts || [];

    if (!cms.editMode && orders[activePersonNo].orderId > 0 && orders[activePersonNo]?.orderRow?.find((o) => o.eventId == this.props.element.id)) {
      discountAmount = orders[activePersonNo]?.orderRow?.find((o) => o.eventId == this.props.element.id)?.discount;
    }

    discounts
      .filter((d) => (d.targetEventId == this.props.element.id && d.value != 0) || (d.targetEventId == null && d.valueType == "Percent" && d.value != 0))
      .sort(function (a, b) {
        return a.value - b.value;
      })
      .map((d) => {
        discountAmount += d.valueType == "Percent" ? (element.props.amount - discountAmount) * (d.value / 100) : d.value;
      });

    const oldPrice = parseFloat(
      form.displayEventSettings.find((ds) => ds.name === "ShowEventIncVat" && ds.value === true) ? displayMoney(parseInt(element.props.amount), element.props.vatPercent) : element.props.amount
    );
    const price = parseFloat(
      form.displayEventSettings.find((ds) => ds.name === "ShowEventIncVat" && ds.value === true)
        ? displayMoney(parseFloat(element.props.amount - discountAmount), element.props.vatPercent)
        : preciseRound(element.props.amount - discountAmount, 2)
    );

    if (!discountAmount) return price + ` ${form.currency || "SEK"}`;

    return (
      <>
        <del style={{ marginRight: 19, fontSize: 15 }}>
          {oldPrice} {` ${form.currency || "SEK"}`}
        </del>
        <span style={{ color: "#4caf50" }}>
          {price > 0 ? price : 0} {` ${form.currency || "SEK"}`}
        </span>
      </>
    );
  };
  render() {
    const { form, template, element, cms, discounts, attendee } = this.props;
    const { loadingBookingRequest, fullbooked } = this.state;
    let isSelected = this.checkboxHandler();

    /* || this.props.element.data.preChecked; */
    let activityName = element.data.display.name ? (element.props ? element.props.name : "") : "";
    /*     console.log(attendee.orders); */
    if (!element.props) return null;
    if (element && element.data && element.data.hidden && !cms.editMode) return null;
    else
      return (
        <div style={{ padding: element.data.padding.toString().includes("px") ? element.data.padding : element.data.padding + "px", width: "100%" }}>
          {element.data.hidden && (
            <div className="hidden-element">
              <i className="fa fa-eye-slash hidden-element-icon" />
            </div>
          )}

          <Row style={{ margin: "0px" }}>
            <Col sm={8} md={8} style={{ display: "inline-flex", width: "40%", padding: "0px" }} className="responsive-col-wrapper">
              <JirangoCheckbox2
                editable={cms.editMode}
                labelName={activityName}
                textStyle={{
                  ...template.content.text,
                }}
                hideCheckbox={fullbooked && !cms.editMode}
                replacementContent={
                  fullbooked && !cms.editMode ? (
                    <Badge color="danger" style={{ ...template.content.text, padding: "10px", margin: "6px 5px", maxHeight: "36px", color: "#fff" }}>
                      Fullbokad
                    </Badge>
                  ) : undefined
                }
                loaderIcon={loadingBookingRequest}
                boxStyle={{
                  ...template.content.button,
                }}
                checkboxIsDisabled={cms.editMode || (!cms.editMode && this.isChangeLocked() === true)}
                isReadonly={element.data.readOnly}
                labelPlacement={"end"}
                labelOnchange={this.handleChange}
                id={"props.name"}
                boxType={this.isRadio() ? "radio" : "checkbox"}
                checkOnchange={this.checkAvailableStatus}
                isSelected={isSelected}
                /*       isSelected={this.props.attendee?.orders[attendee.activePersonNo]?.orderRow?.find(or => or.eventId == this.props.element.id)} */
              />
            </Col>

            {form.displayEventSettings.find((ds) => ds.name === "ShowEventPrice" && ds.value === true) ? (
              <Col
                sm={6}
                md={6}
                style={{
                  display: "inline-flex",
                  width: "20%",
                  flex: 100,
                  padding: "0px",
                }}
                className="responsive-col-wrapper"
              >
                <InputGroup>
                  {!element.data.hidePrice ? (
                    <Label className="money-text" style={{ ...template.content.text, fontWeight: "bold" }}>
                      {this.displayDiscount()}
                    </Label>
                  ) : null}
                </InputGroup>
              </Col>
            ) : null}
          </Row>
          <Row
            style={{
              display: "",
              width: "100%",
              margin: "0px",
              marginLeft: "27px",
            }}
          >
            <Col style={{ padding: "0px" }}>
              {form.displayEventSettings.find((ds) => ds.name === "ShowEventStartDateTime" && ds.value === true) ||
              form.displayEventSettings.find((ds) => ds.name === "ShowEventEndDateTime" && ds.value === true) ||
              form.displayEventSettings.find((ds) => ds.name === "ShowEventStartTime" && ds.value === true) ||
              form.displayEventSettings.find((ds) => ds.name === "ShowEventEndTime" && ds.value === true) ? (
                <Row>
                  <Col sm={6} md={6} style={{ display: "inline-flex", width: "40%", flex: 100 }} className="responsive-col-wrapper">
                    <InputGroup>
                      <Label style={{ ...template.content.text }}>
                        {form.displayEventSettings.find((ds) => ds.name === "ShowEventStartDateTime" && ds.value === true) || element.data.display.startTime
                          ? this.formatDate(element.props.startDateTime, "startDate", "startTime")
                          : null}{" "}
                        -
                        {form.displayEventSettings.find((ds) => ds.name === "ShowEventStartTime" && ds.value === true) ||
                        form.displayEventSettings.find((ds) => ds.name === "ShowEventEndTime" && ds.value === true)
                          ? this.formatDate(element.props.endDateTime, "endDate", "endTime")
                          : null}
                      </Label>
                    </InputGroup>
                  </Col>{" "}
                </Row>
              ) : null}
              {form.displayEventSettings.find((ds) => ds.name === "ShowEventVenue" && ds.value === true) || form.displayEventSettings.find((ds) => ds.name === "ShowEventCity" && ds.value === true) ? (
                <Row>
                  <Col style={{ display: "inline-flex" }}>
                    <InputGroup>
                      {element.data.locationLabel ? (
                        <ContentEditable
                          style={
                            template &&
                            template.content && {
                              ...template.content.text,
                              minWidth: "20px",
                              marginRight: "10px",
                            }
                          }
                          innerRef={this.contentEditable}
                          html={element.data.locationLabel}
                          disabled={!cms.editMode}
                          onChange={(e) => this.handleChange(e, "data.locationLabel")}
                          tagName="label"
                        />
                      ) : null}
                      <Label style={{ ...template.content.text }}>
                        {form.displayEventSettings.find((ds) => ds.name === "ShowEventVenue" && ds.value === true) ? element.props.venue : ""}{" "}
                        {form.displayEventSettings.find((ds) => ds.name === "ShowEventCity" && ds.value === true) ? element.props.city : ""}
                      </Label>
                    </InputGroup>
                  </Col>
                </Row>
              ) : null}
              {form.displayEventSettings.find((ds) => ds.name === "ShowEventMax" && ds.value === true) ? (
                <Row>
                  <Col style={{ display: "inline-flex" }}>
                    <InputGroup>
                      {element.data.maxLabel ? (
                        <ContentEditable
                          style={
                            template &&
                            template.content && {
                              ...template.content.text,
                              minWidth: "20px",
                              marginRight: "10px",
                            }
                          }
                          innerRef={this.contentEditable}
                          html={element.data.maxLabel}
                          disabled={!cms.editMode}
                          onChange={(e) => this.handleChange(e, "data.maxLabel")}
                          tagName="label"
                        />
                      ) : null}
                      <Label style={{ ...template.content.text }}>{element.props.max} </Label>
                    </InputGroup>
                  </Col>
                </Row>
              ) : null}
              {form.displayEventSettings.find((ds) => ds.name === "ShowEventDescription" && ds.value === true) && element.props.description && element.props.description.length > 0 ? (
                cms.editMode /* && form.selectedElement && form.selectedElement.contentId === element.contentId  */ ? (
                  <div
                    className="styleWrapper"
                    style={{ width: "98%", margin: element.data.descriptionMargin.toString().includes("px") ? element.data.descriptionMargin : element.data.descriptionMargin + "px" }}
                  >
                    <style>{`${toKebabCase(template.content, true)} ${!form.selectedElement ? ".tox-tinymce { opacity: 0}" : ""}`}</style>
                    <TinyEditor
                      value={element.props.description}
                      editMode={form.selectedElement && form.selectedElement.contentId === element.contentId}
                      onChange={this.handleChange}
                      slimFormat={true}
                      path={"props.description"}
                      style={/* template.template ? toKebabCase(template.template.content, false) :  */ ""}
                    />
                  </div>
                ) : (
                  <Row>
                    <Col>
                      <div
                        className="styleWrapper"
                        style={{ width: "98%", margin: element.data.descriptionMargin.toString().includes("px") ? element.data.descriptionMargin : element.data.descriptionMargin + "px" }}
                      >
                        <style>{`${toKebabCase(template.content, true)} ${!form.selectedElement ? ".tox-tinymce { opacity: 0}" : ""}`}</style>
                        <ContentEditable
                          style={
                            template &&
                            template.content && {
                              ...template.content.text,
                              minWidth: "20px",
                              marginRight: "10px",
                            }
                          }
                          innerRef={this.contentEditable}
                          html={element.props.description}
                          disabled={!cms.editMode}
                          onChange={(e) => this.handleChange(e, "props.description")}
                          tagName="div"
                        />
                      </div>
                    </Col>
                  </Row>
                )
              ) : null}
            </Col>
          </Row>
          <hr style={{ padding: "0px", margin: "0px" }} />
        </div>
      );
  }
}
function mapStateToProps(state) {
  return {
    form: state.form,
    template: state.template.template,
    cms: state.cms,
    attendee: state.attendee,
    orders: state.attendee.orders,
    activePersonNo: state.attendee.activePersonNo,
    discounts: state.attendee.orders && state.attendee.orders[state.attendee.activePersonNo] ? state.attendee.orders[state.attendee.activePersonNo]?.discounts : [],
  };
}

export default connect(mapStateToProps)(Event);
